export default "__VITE_ASSET__Cd4zQTXT__"